import React from 'react';
import { useNavigate } from 'react-router-dom';
import Seo from '../../components/Seo';
import MessagesModal from '../../components/MessagesModal';
import { useAuth } from '../../contexts/AuthContext';

export default function MessagesPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  if (loading) return <main className="p-5 text-center">Loading messages…</main>;
  if (!user) {
    return (
      <main className="p-5 text-center">
        <Seo title="Messages | Pool 4 Real" description="Pool 4 Real conversations." path="/messages" robots="noindex,follow" />
        <h1>Messages</h1>
        <p>Sign in to open your Pool 4 Real conversations.</p>
        <button className="btn btn-warning" onClick={() => navigate('/login')}>Sign in</button>
      </main>
    );
  }
  return (
    <main>
      <Seo title="Messages | Pool 4 Real" description="Pool 4 Real conversations." path="/messages" robots="noindex,follow" />
      <MessagesModal show onClose={() => navigate('/feed')} />
    </main>
  );
}
